export default "__VITE_ASSET__7qDxsGDe__"